// @core/api/endpoints/workflow/list_test_cases.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTestCasesResponse,
} from '../../../types/workflow';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/workflow';

/**
 * List test cases
 * Returns all test cases for a pipeline.
 */
export async function ListTestCases(
  pipeline_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTestCasesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/pipelines/:pipeline_id/test-cases`;
  requestPath = requestPath.replace(':pipeline_id', encodeURIComponent(pipeline_id));
  const requestOptions = options;
  return client.get<ListTestCasesResponse>(requestPath, { ...requestOptions, params });
}
